<ul class="filters">
  <li>
    <app-user-restrictions-filter
      [title]="'User Type filter'"
      [tooltip]="'Search for a user type'"
      [filterState]="userTypeFilterState">
    </app-user-restrictions-filter>
  </li>
  <li>
    <app-user-restrictions-filter
      [title]="'Department filter'"
      [tooltip]="'Search for a department'"
      [filterState]="departmentFilterState">
    </app-user-restrictions-filter>
  </li>
  <li>
    <app-user-restrictions-filter
      [title]="'Private Label filter'"
      [tooltip]="'Search for a private label'"
      [filterState]="privateLabelFilterState">
    </app-user-restrictions-filter>
  </li>
</ul>
